// OAuth 동의 부탁을 주소창에서 꺼낸다.
//
// 동의 화면(`consent.tsx`)은 늦게 받는다 — 문(`Gate`)이 처음부터 알아야 하는 것은 "부탁이 있는가"
// 하나뿐이라, 그 판정만 여기 두어 화면이 첫 청크를 끌고 오지 않게 한다(docs/design.md D8).

export interface ConsentIntent {
  client_id: string
  redirect_uri: string
  scopes: string
  /** 앱이 준 그대로 돌려준다. 우리가 뜻을 캐지 않는다. */
  state: string | null
}

/** 주소창에서 동의 부탁을 꺼낸다. `/oauth/authorize?client_id=…`. */
export function consent_in(
  loc: { pathname: string; search: string } | undefined,
): ConsentIntent | null {
  if (loc === undefined || !/^\/oauth\/authorize\/?$/.test(loc.pathname)) return null
  const q = new URLSearchParams(loc.search)
  const client_id = q.get('client_id')
  const redirect_uri = q.get('redirect_uri')
  // 셋 중 하나라도 없으면 부탁이 아니다. 반쪽짜리를 추측해 채우지 않는다.
  if (client_id === null || redirect_uri === null) return null
  return {
    client_id,
    redirect_uri,
    scopes: q.get('scope') ?? '',
    state: q.get('state'),
  }
}
